interface WatermarkProps {
    text: string,
}

function Watermark({ text } : WatermarkProps) {
    return <div className="watermark d-none d-print-block">{text}</div>
}

export default Watermark;